import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { FormattedMessage } from "react-intl";

import { ApiClient } from "../../utils/Api";
import ProviderInfo from "../../components/ProviderInfo";
import { PageLayout, PageContent, PageTitle, Container, RichText } from "../../components/";

const Wrapper = styled.article`
  padding: 1rem 0;
`;

class PrivacyPolicy extends React.Component {
  state = {
    privacyPolicy: "",
  };

  async componentDidMount() {
    const { provider } = this.props;
    const privacyPolicy = await new ApiClient().providerPrivacyPolicy(provider.id);

    this.setState({ ...privacyPolicy });
  }

  render() {
    const { provider } = this.props;
    const { privacyPolicy } = this.state;
    return (
      <PageLayout>
        <PageTitle
          title={provider.name}
          subTitle={<FormattedMessage id="pages.PrivacyPolicy.title" />}
          contact={provider.contacts[0]}
          // logo={provider.logo}
          // image={titleImage(provider)}
        />
        <PageContent>
          <Wrapper>
            <Container>
              <ProviderInfo provider={provider} />
              <RichText text={privacyPolicy || ""} />
            </Container>
          </Wrapper>
        </PageContent>
      </PageLayout>
    );
  }
}

PrivacyPolicy.propTypes = {
  provider: PropTypes.object.isRequired,
};

export default PrivacyPolicy;
